import { useEffect,useCallback, useRef, useState } from "react";
import {
  SESSION_CONTINUE_EVENT,
  SESSION_CONTINUE_LOCAL_STORAGE_KEY,
  TIMEOUT_LIMIT_FOR_SESSION_MESSAGE,
} from "../Constant";
import { useRefreshToken } from "./useRefreshToken";
import { RootState } from "../store";
import { useSelector } from "react-redux";
type IdleTimerOptions = {
  timeout?: number;
};

export const useIdleTimer = ({
  timeout = TIMEOUT_LIMIT_FOR_SESSION_MESSAGE,
}: IdleTimerOptions = {}) => {
  const [time, setTime] = useState(0);
  const [isIdle, setIsIdle] = useState(false);
  const lastActivityTime = useRef<number>(Date.now());

  const isSessionMessageOpen = useSelector(
    (state: RootState) => state.UserSessionMessageSlice.display
  );

  useRefreshToken(); // Call the useRefreshToken hook to ensure token refresh logic is executed
  // check if any activity is detected
 const handleActivity = useCallback(() => {
    lastActivityTime.current = Date.now(); // update last activity time
    setIsIdle(false); // reset idle state
    setTime(0);
  },[]);

  // check if user is idle
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (
        event.key !== SESSION_CONTINUE_LOCAL_STORAGE_KEY ||
        event.newValue === null
      ) {
        return;
      }

      handleActivity();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener(SESSION_CONTINUE_EVENT, handleActivity);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(SESSION_CONTINUE_EVENT, handleActivity);
    };
  }, [handleActivity]);

  useEffect(() => {
    if (time > timeout) {
      setIsIdle(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);

  useEffect(() => {
    // start the idle timer
    const intervalId = setInterval(() => {
         // do not update time if session message is open
      const currentTime = Date.now();
      const elapsedTime = currentTime - lastActivityTime.current;
      setTime(elapsedTime);
    }, 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [timeout]);

  useEffect(() => {
    // add event listener
    // can be attached to other events like (keydown, scroll, click, touchstart, etc)
    if (!isSessionMessageOpen) {
      window.addEventListener("mousemove", handleActivity);
      window.addEventListener("wheel", handleActivity);
      window.addEventListener("click", handleActivity);
      window.addEventListener("keydown", handleActivity);
      window.addEventListener("touchstart", handleActivity);
      window.addEventListener("touchmove", handleActivity);
      window.addEventListener("scroll", handleActivity);
      window.addEventListener("focus", handleActivity); // focus event to reset idle timer on tab focus
    }

    return () => {
      // remove event listener
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("wheel", handleActivity);
      window.removeEventListener("click", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
      window.removeEventListener("touchmove", handleActivity);
      window.removeEventListener("scroll", handleActivity);
      window.removeEventListener("focus", handleActivity); // focus event to reset idle timer on tab focus
    };
  }, [handleActivity,isSessionMessageOpen]);

  return { time, isIdle };
};